import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/auth-provider';
import { PrimeReactProvider } from 'primereact/api';

const publicUrl = process.env.PUBLIC_URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <Router>
        <PrimeReactProvider>
            <AuthProvider>
                <AppWrapper></AppWrapper>
            </AuthProvider>
        </PrimeReactProvider>
    </Router>
    // </React.StrictMode>
);

// activate service worker
// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', function () {
//         navigator.serviceWorker.register('/service-worker.js').then(
//             function (registration) {
//                 console.log('ServiceWorker registration successful with scope: ', registration.scope);
//             },
//             function (err) {
//                 console.log('ServiceWorker registration failed: ', err);
//             }
//         );
//     });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
